import { render, staticRenderFns } from "./SelectDoctor.vue?vue&type=template&id=b13300e6&scoped=true"
import script from "./SelectDoctor.vue?vue&type=script&lang=js"
export * from "./SelectDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13300e6",
  null
  
)

export default component.exports